import { useAppState } from "../state/App";

export function useIsKiosk() {
  const {
    state: { isKiosk },
  } = useAppState();
  return isKiosk;
}
